<template>
  <div dir="ltr">
    <div class="title_container">
      <page-title v-if="main_position" title="Related Offers"></page-title>
      <p v-else>Related Offers</p>
    </div>
    <div v-if="is_loading" dir="ltr">
      <div class="relative loading center_horizontal"></div>
    </div>
    <div v-else class="display_table min_width_100_percent">
      <div class="related_position_adder is-flex is-align-items-center">
        <related-position-adder @input="refresh" :payload="{ position_id: position_id }" :filter_related_resources="related_resources">
        </related-position-adder>
      </div>
      <nav class="buttons is-outlined my-3 mx-4">
        <button @click="prevPage" class="button mx-4" :disabled="page == 1">Previous</button>
        <button @click="nextPage" class="button mx-4">Next page</button>
      </nav>
      <div class="card">
        <div class="card-body">
          <div class="table-responsive">
            <table dir="ltr" id="table" class="table center-aligned-table">
              <tr>
                <th style="background: transparent;">
                  <p>{{ unique_applicants.length > 0 ? 'APPLICANTS' : 'NO APPLICANTS' }}</p>
                </th>
                <th v-for="related_resource in related_resources" :key="related_resource.id" class="padding_0"
                    :class="{ is_main: related_resource.is_main }" style="vertical-align: top;">
                  <related-resource :related_resource="related_resource"></related-resource>
                </th>
              </tr>
              <tbody>
                <tr v-for="(applicant, index) in unique_applicants" :key="index" :class="{ odd: index % 2 == 0 }">
                  <td style="position: sticky; left: 0;" :class="{ td_odd: index % 2 == 0, td_even: index % 2 != 0 }">
                    <div class="is-flex is-justify-content-flex-end">
                      <div class="horizontal_space"></div>
                      <link-entity :payload="applicant"></link-entity>
                      <div class="horizontal_space"></div>
                      <message :payload="applicant"
                               :additional_data="{ resource_type: 'Applicant', endpoint: '/users/', headers: 'admin_headers' }">
                      </message>
                    </div>
                  </td>
                  <td v-for="related_resource in related_resources" :key="related_resource.id">
                    <related-offer :offer="getOffer({ position_id: related_resource.leader.position.id, applicant_id: applicant.resource_id })"
                                   :position_id="related_resource.leader.position.id" :applicant_id="applicant.resource_id">
                    </related-offer>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'

import { compareScore } from '@/custom/classes/related_resources_helper.js'
import Message from '@/components/Message'
import LinkEntity from '@/components/LinkEntity'
import RelatedResource from '@/components/RelatedResource'
import RelatedPositionAdder from '@/components/RelatedPositionAdder'
import PageTitle from '@/components/PageTitle'
import RelatedOffer from '@/components/RelatedOffer'
export default {
  name: 'related-offers',
  data () {
    return {
      is_loading: true,
      main_position: undefined,
      position_id: this.$route.query.position_id,
      offers_by: {},
      related_resources: [],
      unique_applicants: [],
      show_applicants: false,
      is_adding_position: false,
      is_search_positions_by_company: false,
      position_search_term: '',
      position_search_results: [],
      page: 1
    }
  },
  computed: {
    ...mapGetters('offerStatuses', ['getGreenList', 'getOrangeList'])
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.show_applicants = false
      this.is_loading = true
      this.$network_utils.getPosition({ id: this.position_id }).then(response => {
        this.main_position = response
        this.getRelatedResources().then(response => {
          this.related_resources = response
          this.related_resources.sort((a, b) => {
            return b.leader.position.is_hot - a.leader.position.is_hot
          })
          this.related_resources.unshift({ score: 100, leader: { position: this.main_position }, is_main: true })
          this.getRelatedOffers()
        })
      })
    },
    prevPage () {
      this.page = Math.max(this.page - 1, 1)
      this.is_loading = true
      this.offers_by = {}
      this.unique_applicants = []
      this.getRelatedOffers()
    },
    nextPage () {
      this.page = this.page + 1
      this.is_loading = true
      this.offers_by = {}
      this.unique_applicants = []
      this.getRelatedOffers()
    },
    clearData () {
      this.position_search_results = false
      this.is_adding_position = false
      this.offers_by = {}
      this.related_resources = []
    },
    getRelatedOffers () {
      let all_position_ids = this.related_resources.map(related_resource => related_resource.leader.position.id).join(',')
      this.$network_utils.getRelatedOffers({ position_ids: this.position_id + ',' + all_position_ids, page: this.page, per: 10, sort: 'id' }).then(response => {
        this.is_loading = false
        this.createUniqueApplicants(response)
        this.createOffersBy(response)
        this.$nextTick(() => {
          this.show_applicants = true
        })
      })
    },
    getRelatedResources () {
      return this.$network_utils.getRelatedResources({
        follower_type: 'Position',
        follower_id: this.position_id,
        approval_statuses: 'true,NULL'
      })
    },
    createUniqueApplicants (offers) {
      offers.map(offer => {
        if (this.unique_applicants.filter(applicant => applicant.resource_id == offer.applicant.resource_id).length == 1) {
          let applicant_array_index = this.getUniqueApplicantIndexById(offer.applicant.resource_id)
          this.unique_applicants[applicant_array_index].score += this.getScoreRecipe(offer)
          return
        }
        offer.applicant.score = this.getScoreRecipe(offer)
        this.unique_applicants.push(offer.applicant)
      })
      this.unique_applicants.sort(compareScore)
    },
    refresh () {
      this.clearData()
      this.init()
    },
    createOffersBy (offers) {
      offers.map(offer => {
        let key = offer.position.id + '-' + offer.applicant.resource_id
        this.offers_by[key] = offer
      })
    },
    getUniqueApplicantIndexById (applicant_id) {
      for (let i = 0; i < this.unique_applicants.length; i++) {
        if (this.unique_applicants[i].resource_id == applicant_id) {
          return i
        }
      }
    },
    getScoreRecipe (offer) {
      if (offer.status == undefined) {
        return 0
      }
      if (this.getGreenList.map(s => s.name).includes(offer.status.name)) {
        return 3
      }
      if (this.getOrangeList.map(s => s.name).includes(offer.status.name)) {
        return 1
      }
      return 0
    },
    getOffer (params) {
      return this.offers_by[params.position_id + '-' + params.applicant_id]
    },
    ...mapMutations('modals', ['create'])
  },
  components: {
    Message,
    LinkEntity,
    RelatedResource,
    RelatedPositionAdder,
    PageTitle,
    RelatedOffer
  }
}
</script>
<style scoped>
  .title_container {
    margin-top: 40px;
    margin-left: 30px;
  }
  .card {
    margin-top: 20px;
    margin-right: 60px;
  }
  th, tr, td, tbody td { outline: thin solid rgba(0, 0, 0, 0.1); z-index: 100000 }
  .related_position_adder{
    z-index: 100000000;
    width: 100%;
    text-align: center;
    justify-content: center;
  }
  th{
    position: sticky;
    top: 0;
    box-shadow: 0px 3px 3px -3px rgba(0, 0, 0, 0.75);
    background-color: white;
    min-width: 300px !important;
  }
  td, tr {
    height: 65px;
  }
  .is_adding_position{
    pointer-events: none;
    opacity: 0.5;
  }
  th.is_main{
    outline: thin solid darkorange;
    background-color: #F2F2F2;
  }
</style>
